import { useFriendContext } from '../utils/ContextProviders/FriendContext';
import { useAppContext } from '../utils/ContextProviders/AppContext';
import { STEPS } from '../utils/constants/progressSteps';

export function useVerifyUserFlowLocation() {
  const { goToStep } = useAppContext();
  const { friend } = useFriendContext();

  const validateAccountCreation = () => {
    if (!friend.email || !friend.firstName
            || !friend.lastName || !friend.phoneNumber || !friend.password) {
      return false;
    }
    return true;
  };

  const validatePhoneNumberVerification = () => friend.isPhoneValidated;

  function verifyUserFlowLocation() {
    const page = window.location.pathname.replace(/\/$/, '');
    switch (page) {
      case STEPS.VERIFY.url:
        if (!validateAccountCreation()) {
          goToStep(STEPS.CREATE_ACCOUNT);
        }
        break;
      case STEPS.PERSONAL_INFO.url:
        if (!validateAccountCreation()) {
          goToStep(STEPS.CREATE_ACCOUNT);
        } else if (validateAccountCreation() && !validatePhoneNumberVerification()) {
          goToStep(STEPS.VERIFY);
        }
        break;
      default:
        break;
    }
  }
  return { validateAccountCreation, validatePhoneNumberVerification, verifyUserFlowLocation };
}

export default useVerifyUserFlowLocation;
